export default __webpack_public_path__ + "static/media/icon-minus.65a5e70b.svg";